import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.admins;

export const adminsSelector = createSelector(getState, (state) => state.admins);
export const adminsMetaSelector = createSelector(getState, (state) => state.adminsMeta);
export const isLoadingAdminsSelector = createSelector(getState, (state) => state.isLoadingAdmins);

export const selectedAdminSelector = createSelector(getState, (state) => state.selectedAdmin);
export const isLoadingSelectedAdminSelector = createSelector(
  getState,
  (state) => state.isLoadingSelectedAdmin,
);

export const adminErrorsSelector = createSelector(getState, (state) => state.errors);
